module.exports = __webpack_public_path__ + "static/media/men_playing.29bb2008.png";